import WeChatAuth from './WechatAuth'
import url from 'url'
import querystring from 'querystring'
import tools from '@/tools/tools.js'

export default {
  install (Vue, options) {
    let weChatAuth = new WeChatAuth(options)
    let router = options.router
    if (!router) return false

    function urlCodeQueryFilter (code) {
      tools.saveLog('urlCodeQueryFilter', `
        code: ${code}
      `)
      if (code) {
        weChatAuth.setAuthCode(code)
        weChatAuth.removeUrlCodeQuery()
      }
    }

    function checkRouterAuth (to, from, next) {
      tools.saveLog('checkRouterAuth', `function`)
      let authCode = weChatAuth.getAuthCode()
      // if ((!to.meta || !to.meta.auth) && !authCode) {
      //   alert("return 1")
      //   return true
      // }
      // alert('authCode' + authCode + '/ openId' + weChatAuth.getOpenId())
      if (!authCode && !weChatAuth.getOpenId()) {
        weChatAuth.openAuthPage(window.location.href)
        return false
      } else if (authCode && !weChatAuth.getOpenId()) {
        weChatAuth.getCodeCallback(next)
        return false
      }
      return true
    }

    function beforeEach (to, from, next, str) {
      tools.saveLog('beforeEach', `function`)
      let query = querystring.parse(url.parse(window.location.href).query)
      let code = query.code
      const appId = tools.getUrlParams('appid')
      if (appId !== null && appId !== undefined && appId !== '') {
        window.localStorage.setItem('appId', appId)
      }
      urlCodeQueryFilter(code)
      if (!code && !checkRouterAuth(to, from, next)) {
        return false
      }
      next()
    }

    router.beforeEach((to, from, next) => {
      let openId = window.localStorage.getItem("openId")
      if (openId !== undefined && openId !== null && openId.indexOf("orkwnw") !== -1) {
        window.localStorage.removeItem("openId")
        window.localStorage.removeItem('access_token')
      }
      let appId = window.localStorage.getItem("appId")
      if (appId !== undefined && appId !== null && appId.indexOf("wx12a9b23a4a005be7") !== -1) {
        window.localStorage.removeItem("appId")
      }
      console.log(openId + "===" + appId)
      let path = window.location.href
      const index = path.indexOf('/notlogin')
      const maintain = path.indexOf('/maintain')
      if (index !== -1 || maintain !== -1 || path.indexOf('/register_Test') !== -1) {
        next()
        return
      }
      // flag = (path.indexOf('register') !== -1 || path.indexOf('ElecProtocols') !== -1)
      beforeEach(to, from, next, '')
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugin/wechatauth/index.js